import { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  LayoutDashboard,
  ListChecks,
  ClipboardList,
  FileText,
  Menu,
  ChevronLeft,
  ChevronRight,
  ArrowLeft,
  LogOut,
} from 'lucide-react';
import { logoutUser } from '../../../../services/session';
import { useAuthSession } from '../../../../contexts/AuthSessionContext';
import './checklist.css';

const ChecklistLayout = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isOwner, cheflistAdmin } = useAuthSession();

  const canManageChecklist = isOwner || cheflistAdmin;
  const isMobile = () => window.innerWidth <= 768;

  const openMobile = () => setMobileOpen(true);
  const closeMobile = () => setMobileOpen(false);

  const handleToggle = () => {
    if (isMobile()) {
      openMobile();
      return;
    }
    setCollapsed((value) => !value);
  };

  const handleLogout = async () => {
    await logoutUser();
    navigate('/');
  };

  return (
    <div className="checklist-layout">
      <div className={`checklist-overlay${mobileOpen ? ' open' : ''}`} onClick={closeMobile} />

      <motion.aside
        animate={{ width: collapsed && !isMobile() ? 72 : 240 }}
        className={`checklist-sidebar${collapsed ? ' collapsed' : ''} ${mobileOpen ? ' open' : ''}`}
      >
        <div className="checklist-header">
          <button
            className="checklist-collapse-btn"
            onClick={() => (isMobile() ? closeMobile() : setCollapsed((value) => !value))}
            aria-label={collapsed ? 'Expandir menu' : 'Recolher menu'}
            title={collapsed ? 'Expandir' : 'Recolher'}
          >
            {collapsed && !isMobile() ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
          </button>
          {!collapsed && !isMobile() && (
            <button
              className="checklist-back-btn"
              onClick={() => navigate('/products')}
              aria-label="Voltar para produtos"
              title="Voltar"
            >
              <ArrowLeft size={20} />
            </button>
          )}
          <div className="checklist-logo-area">
            <img src="/cheflist.png" alt="Logo" className="checklist-logo" />
          </div>
        </div>

        <nav className="checklist-nav">
          <NavLink end to="/checklist" onClick={closeMobile}>
            <LayoutDashboard size={20} />
            <span>Dashboard</span>
          </NavLink>

          {canManageChecklist && (
            <>
              <NavLink to="execucoes" onClick={closeMobile}>
                <ListChecks size={20} />
                <span>Execuções</span>
              </NavLink>
              <NavLink to="modelos" onClick={closeMobile}>
                <ClipboardList size={20} />
                <span>Modelos</span>
              </NavLink>
            </>
          )}

          <NavLink to="planos" onClick={closeMobile}>
            <FileText size={20} />
            <span>Plano de Ação</span>
          </NavLink>
        </nav>

        <div className="checklist-logout-area">
          <button className="checklist-logout-btn" onClick={() => void handleLogout()}>
            <LogOut size={20} />
            <span>Sair</span>
          </button>
        </div>
      </motion.aside>

      <main className={`checklist-content ${collapsed && !isMobile() ? 'is-collapsed' : ''}`}>
        <button className="checklist-mobile-menu-btn" onClick={handleToggle} aria-label="Abrir menu">
          <Menu size={24} />
        </button>

        <div className="checklist-container">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default ChecklistLayout;
